import { DestinatarioMatricola, Matricola } from '../core-assistenza/models';

export enum StatoOrdine {
    Inviato = 1,
    PresoInCarico = 2,
    InCorso = 3,
    Chiuso = 4,
    Rifiutato = 5,
}

export interface ConsumabileMatricola{
    codice: string,
    descrizione: string,
    coloreSfondo: string,
    coloreIcona: string,
    quantita: number
}

export interface Ordine {
    numeroMacchina: string,
    codice: string,
    ubicazione: string,
    descrizione: string,
    numero: number,
    data: Date,
    stato: StatoOrdine,
    userId: string,
    userName: string,
    idOrdine: string,
    idSpecifica: string,
    motivoRifiuto: string,
    referente: string,
    righe: ReadonlyArray<OrdineRiga>
}

export interface MatricolaCarrello {
    matricola: Matricola,
    righe: Array<OrdineRiga>
}

export interface OrdineRiga {
    idSpecifica: string,
    codice: string, 
    quantita: number,
    descrizione: string,
    colore: string
}

export interface OrdineNuovo {
    idOrdine?: string,
    inviaMail: boolean,
    email: string,
    referente: string,
    righe: ReadonlyArray<OrdineRiga>
}

export interface OrdiniState {
    destinatariMatricole: { lista: ReadonlyArray<DestinatarioMatricola>, refreshCache: boolean },
    carrelloConsumabili: { lista: ReadonlyArray<MatricolaCarrello> },
    ordini: { lista: ReadonlyArray<Ordine>, page: number, pageSize: number, itemsCount: number, refreshCache: boolean },
    consumabili: { lista: ReadonlyArray<ConsumabileMatricola>, refreshCache: boolean }
}